export const saveToLocalStorage = (key: string, value: string) => {
  try {
      localStorage.setItem(key, value);
  } catch (error) {
      console.error('Error saving to local storage', error);
  }
};
